<template>
  <div class="add">
    <basic-container>
      <div class="add-header">
        <div class="left-title">新增台班</div>
        <el-button
          size="small"
          plain
          type="primary"
          style="
            margin-right: 20px;
            margin-bottom: 0;
            background: #fff;
          "
          @click="back"
        >
          返回
        </el-button>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="158px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择项目:" prop="projectInfoId">
          <el-select
            v-model="ruleForm.projectInfoId"
            placeholder="请选择"
            @change="changeProject"
          >
            <el-option
              :label="item.projectName"
              :value="item.id"
              v-for="(item, i) in projectList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="挖机员:"
          prop="staffId"
          v-if="ruleForm.projectInfoId"
        >
          <el-select v-model="ruleForm.staffId" placeholder="请选择">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, i) in signList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班次:" prop="inShiftType">
          <el-select v-model="ruleForm.inShiftType" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              v-for="(item, i) in shiftsList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班次时间:" prop="inShiftTime">
          <el-date-picker
            type="date"
            placeholder="请选择"
            value-format="yyyy-MM-dd"
            v-model="ruleForm.inShiftTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="班次:" prop="inShiftType">
          <el-select v-model="ruleForm.inShiftType" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              v-for="(item, i) in shiftsList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="挖机类型:" prop="inType">
          <el-select v-model="ruleForm.inType" placeholder="请选择">
            <el-option
              :label="item.itemName"
              :value="item.itemValue"
              v-for="(item, i) in inTypeList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="机械型号:"
          prop="machineId"
          v-if="ruleForm.projectInfoId"
        >
          <el-select v-model="ruleForm.machineId" placeholder="请选择">
            <el-option
              :label="item.machineCode"
              :value="item.id"
              v-for="(item, i) in machineList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:" prop="startDatetime">
          <el-date-picker
            type="datetime"
            placeholder="请选择"
            @change="changeStart"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.startDatetime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endDatetime">
          <el-date-picker
            type="datetime"
            placeholder="请选择"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="changeEnd"
            v-model="ruleForm.endDatetime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="时长:" prop="workTime">
          <el-input
            disabled
            placeholder="输入时间后系统识别"
            v-model="ruleForm.workTime"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="作业类型:"
          prop="ledgerType"
          v-if="ruleForm.projectInfoId"
        >
          <el-select v-model="ruleForm.ledgerType" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              v-for="(item, i) in manHourTypeList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="单位:"
          prop="unitWork"
          v-if="ruleForm.projectInfoId"
        >
          <el-select v-model="ruleForm.unitWork" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              v-for="(item, i) in inUnitWorkList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="地块:"
          prop="landName"
          v-if="ruleForm.projectInfoId && landList.length > 0"
        >
          <el-select v-model="ruleForm.landName" placeholder="请选择">
            <el-option
              :label="item"
              :value="item"
              v-for="(item, i) in landList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作业地点:" prop="address">
          <el-input
            placeholder="请输入作业地点"
            v-model="ruleForm.address"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="完成量:" prop="scheduleWork">
          <el-input
            placeholder="请输入完成量"
            type="number"
            v-model="ruleForm.scheduleWork"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="加油升数:"
          prop="refuelingLitres"
          type="number"
          v-if="formPermiss.includes('refuelingLitres')"
        >
          <el-input
            placeholder="请输入加油升数"
            v-model="ruleForm.refuelingLitres"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="加班时长(小时):"
          prop="overtimeHours"
          v-if="formPermiss.includes('overtimeHours')"
        >
          <el-input
            placeholder="请输入加班时长(小时)"
            type="number"
            v-model="ruleForm.overtimeHours"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="费用(元):"
          prop="cost"
          v-if="formPermiss.includes('cost')"
        >
          <el-input
            placeholder="请输入费用(元)"
            v-model="ruleForm.cost"
            type="number"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否餐补:"
          prop="isSubsidizedMeals"
          v-if="formPermiss.includes('isSubsidizedMeals')"
        >
          <el-select v-model="ruleForm.isSubsidizedMeals" placeholder="请选择">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否签证:"
          prop="isVisa"
          v-if="formPermiss.includes('isVisa')"
        >
          <el-select v-model="ruleForm.isVisa" placeholder="请选择">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="开始码表:"
          prop="beginClock"
          v-if="formPermiss.includes('beginClock')"
        >
          <el-input
            placeholder="请输入开始码表"
            v-model="ruleForm.beginClock"
            type="number"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="开始码表拍照:"
          prop="beginClockUrl"
          v-if="formPermiss.includes('beginClockUrl')"
        >
          <el-upload
            action="/upms/file/upload?fileType=image&dir=addLedgerDig/"
            list-type="picture-card"
            multiple
            :headers="headers"
            :class="{'hide-pic':fileList1.length==1}"
            :file-list="fileList1"
            :before-upload="beforeUpload"
            :on-success="(response, file, fileList)=>{handleSuccess(response, file, fileList, '1')}"
             :on-remove="(file, fileList)=>{handleRemove(file, fileList, '1')}"
            :on-error="handleError"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              建议尺寸900*400，最多1张，单个图
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="结束码表:"
          prop="endClock"
          type="number"
          v-if="formPermiss.includes('endClock')"
        >
          <el-input
            placeholder="请输入结束码表"
            v-model="ruleForm.endClock"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="结束码表拍照:"
          prop="endClockUrl"
          v-if="formPermiss.includes('endClockUrl')"
        >
          <el-upload
            action="/upms/file/upload?fileType=image&dir=addLedgerDig/"
            list-type="picture-card"
            multiple
            :limit="1"
            :headers="headers"
            :class="{'hide-pic':fileList2.length==1}"
            :file-list="fileList2"
            :before-upload="beforeUpload"
            :on-success="(response, file, fileList)=>{handleSuccess(response, file, fileList, '2')}"
             :on-remove="(file, fileList)=>{handleRemove(file, fileList, '2')}"
            :on-error="handleError"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              建议尺寸900*400，最多1张，单个图
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注:" prop="ledgerRemark">
          <el-input
            type="textarea"
            placeholder="请输入PC备注"
            :rows="4"
            :show-word-limit="true"
            v-model="ruleForm.ledgerRemark"
          ></el-input>
        </el-form-item>
        <el-form-item label="照片凭证:" prop="ledgerRemark">
          <el-upload
            action="/upms/file/upload?fileType=image&dir=addLedgerDig/"
            list-type="picture-card"
            :class="{'hide-pic':fileList3.length==9}"
            multiple
            :limit="9"
            :headers="headers"
            :file-list="fileList3"
            :before-upload="beforeUpload"
            :on-success="(response, file, fileList)=>{handleSuccess(response, file, fileList, '3')}"
            :on-remove="(file, fileList)=>{handleRemove(file, fileList, '3')}"
            :on-error="handleError"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              建议尺寸900*400，最多9张，单个图
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button size="mini" type="primary" @click="addLedger('ruleForm')">
          保存
        </el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import {
  getProjectList,
  getShiftOfProject,
  addForWorkflow,
  infoList,
  inTypeList,
  getMachineList,
  getSettingAll,
} from "@/api/chain/ledgerDig2";
import store from "@/store";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      fileList3:[],
      fileList2: [],
      headers: {
        Authorization: "Bearer " + store.getters.access_token,
        AuthorizationMD5: store.getters.user_md5, // user_md5
      },
      fileList1: [],
      formPermiss: [],
      inUnitWorkList: [],
      manHourTypeList: [],
      machineList: [],
      inTypeList: [],
      signList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      projectList: [],
      shiftsList: [],
      ruleForm: {
        projectInfoId: "",
        inShiftTime: "",
        inShiftType: "",
        workTime: "",
        staffId: "",
      },
      rules: {
        // beginClock: [
        //   { required: true, message: "请输入开始码表", trigger: "blur" },
        // ],
        // beginClockUrl: [
        //   { required: true, message: "请上传", trigger: "change" },
        // ],
        // endClock: [
        //   { required: true, message: "请输入结束码表", trigger: "blur" },
        // ],
        // endClockUrl: [{ required: true, message: "请上传", trigger: "change" }],
        // isVisa: [{ required: true, message: "请选择", trigger: "change" }],
        // refuelingLitres: [
        //   { required: true, message: "请输入加油升数", trigger: "blur" },
        // ],
        // isSubsidizedMeals: [
        //   { required: true, message: "请选择", trigger: "change" },
        // ],
        // cost: [{ required: true, message: "请输入费用(元)", trigger: "blur" }],
        // overtimeHours: [
        //   { required: true, message: "请输入加班时长(小时)", trigger: "blur" },
        // ],
        landName: [
          { required: true, message: "请输入选择地块", trigger: "change" },
        ],
        inType: [
          { required: true, message: "请选择挖机类型", trigger: "change" },
        ],
        staffId: [
          { required: true, message: "请选择挖机员", trigger: "change" },
        ],
        machineId: [
          { required: true, message: "请选择机械型号", trigger: "change" },
        ],
        ledgerType: [
          { required: true, message: "请选择作业类型", trigger: "change" },
        ],
        unitWork: [
          { required: true, message: "请选择单位", trigger: "change" },
        ],
        projectInfoId: [
          { required: true, message: "请选择项目", trigger: "change" },
        ],
        inShiftTime: [
          { required: true, message: "请选择班次时间", trigger: "change" },
        ],
        inShiftType: [
          { required: true, message: "请选择班次", trigger: "change" },
        ],
        startDatetime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        endDatetime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入作业地点", trigger: "blur" },
        ],
        scheduleWork: [
          { required: true, message: "请输入完成量", trigger: "blur" },
        ],
      },
    };
  },
  computed:{
    ...mapGetters(['tagList']),
  },
  created() {
    getProjectList().then((res) => {
      this.projectList = res.data.data.records;
      console.info(this.projectList);
    });
    getShiftOfProject().then((res) => {
      this.shiftsList = res.data.data;
    });
    inTypeList().then((res) => {
      this.inTypeList = res.data.data;
    });
    getSettingAll().then((res) => {
      this.formPermiss = res.data.data.map((v) => v.key);
      console.info(this.formPermiss["refuelingLitres"]);
    });
  },
  methods: {
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    handleRemove(file, fileList, name) {
      this[`fileList${name}`] = fileList;
    },
    handleSuccess(response, file, fileList, name) {
      this[`fileList${name}`] = fileList;
    },
    handleError(err, file, fileList) {
      this.$message.error(err + "");
    },
    beforeUpload(file) {
      const isPic =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isPic) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG、GIF 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isPic && isLt2M;
    },
    changeProject(val) {
      let tmp = this.projectList.find((v) => v.id == val);
      this.landList = tmp.landParcel ? tmp.landParcel.split(",") : [];
      this.manHourTypeList = tmp.manHourType ? tmp.manHourType.split(",") : [];
      this.inUnitWorkList = tmp.inUnitWork ? tmp.inUnitWork.split(",") : [];
      infoList(val).then((res) => {
        this.signList = res.data.data.inList;
      });
      getMachineList(val).then((res) => {
        this.machineList = res.data.data;
      });
    },
    addLedger(formName) {
      //      row.inShiftType = row.inShiftTypeForm;
      //   row.ledgerType = row.ledgerTypeForm;
      //   row.unitWork = row.unitWorkForm;
      //   row.beginClockUrl =
      //     Array.isArray(row.beginClockUrl) && row.beginClockUrl.length == 0
      //       ? ""
      //       : row.beginClockUrl;
      //   row.endClockUrl =
      //     Array.isArray(row.endClockUrl) && row.endClockUrl.length == 0
      //       ? ""
      //       : row.endClockUrl;
        this.ruleForm.shiftTime = this.ruleForm.inShiftTime;
      if(this.fileList1.length==1){
        this.ruleForm.beginClockUrl=this.fileList1[0].response.link
      }
       if(this.fileList2.length==1){
        this.ruleForm.endClockUrl=this.fileList1[0].response.link
      }
      if(this.fileList3.length>0){
        this.ruleForm.pictureUrl=this.fileList3.map(v=>v.response.link).join(',')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addForWorkflow(this.ruleForm)
            .then((res) => {
              this.$message.success("新增成功");
              let { tag } = this.findTag(this.$route.path);
              this.$store.commit("DEL_TAG", tag);
              this.back();
            })
            .catch(() => {});
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeStart(val) {
      this.ruleForm.workTime = this.calculateHourDifference(
        val,
        this.ruleForm.endDatetime
      );
    },
    changeEnd(val) {
      this.ruleForm.workTime = this.calculateHourDifference(
        this.ruleForm.startDatetime,
        val
      );
      console.info(this.ruleForm.workTime);
    },
    // 计算两个日期时间之间的小时差
    calculateHourDifference(startTime, endTime) {
      console.info(startTime, endTime);
      if (startTime && endTime) {
        const start = new Date(startTime);
        const end = new Date(endTime);

        // 计算时间差（单位为毫秒）
        const timeDiff = Math.abs(end - start);

        // 将毫秒转换为小时数
        const hours = timeDiff / (1000 * 60 * 60);
        const tmpHours = parseFloat(hours.toFixed(2));
        return tmpHours + "小时"; // 保留两位小数
      }
      return "0小时";
    },
    back() {
      this.$router.push({
        path: "/chain/ledgerdig/ledgerDig2",
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-message--success {
  background: #fff;
  box-shadow: 0px 2px 24px 0px rgba(200, 201, 204, 0.5);
  border-radius: 4px;
}
.submit {
  border-top: 1px solid #ededf0;
  padding-top: 8px;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0px;
  background: #fff;
  margin: 0 10px;
  right: -1px;
  z-index: 9999;
  padding-bottom: 35px;
}
.el-upload__tip {
  font-weight: 400;
  font-size: 14px;
  color: #939399;
}
.add {
  height: 100%;
}
.add-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  .left-title {
    font-weight: 500;
    font-size: 16px;
    color: #313133;
  }
}
/deep/.el-date-editor.el-input {
  width: 440px !important;
}

/deep/.el-select {
  width: 440px !important;
}

/deep/.el-range-editor.el-input__inner {
  width: 440px !important;
}

/deep/.el-cascader {
  width: 440px !important;
}
/deep/.el-input {
  width: 440px !important;
}
/deep/.el-textarea {
  width: 440px !important;
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 90px;
  background: #F5F7FA;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  line-height: 80px;
}
/deep/.el-upload-list--picture-card .el-upload-list__item-status-label i {
  position: absolute;
  right: 12px;
  top: 1px;
}
/deep/ .hide-pic .el-upload--picture-card {
		display: none;
}
</style>